//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilogixDetailsForm from "@Broker/@Modules/util-components/filogix/filogix-details-form.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MissingDetailsStep",
  components: {
    FilogixDetailsForm
  },
  props: {
    filogixDetails: {
      type: Object,
      required: true
    },
    importingClients: {
      type: Boolean,
      default: true
    },
    onlyShowProfileNumberField: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filogixDetailsLocal: {
      get() {
        return this.filogixDetails;
      },
      set(value) {
        this.$emit("update:filogixDetails", value);
      }
    }
  }
});